import { useState } from "react";
import { toast } from "sonner";
import { Share2, Link2, Facebook, Twitter, Mail, Check } from "lucide-react";

export const ShareButton = ({ title = "", text = "", className = "" }) => {
  const [copied, setCopied] = useState(false);
  const url = typeof window !== "undefined" ? window.location.href : "";
  const shareText = text || title;

  const nativeShare = async () => {
    if (navigator.share) {
      try { await navigator.share({ title, text: shareText, url }); } catch { /* cancelled */ }
    } else {
      copyLink();
    }
  };
  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      toast.success("Link copied — share the hope 💛");
      setTimeout(() => setCopied(false), 1800);
    } catch {
      toast.error("Couldn't copy the link.");
    }
  };
  const openPopup = (href) => window.open(href, "_blank", "noopener,noreferrer,width=600,height=560");
  const fb = () => openPopup(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`);
  const x = () => openPopup(`https://twitter.com/intent/tweet?url=${encodeURIComponent(url)}&text=${encodeURIComponent(shareText)}`);
  const email = () => { window.location.href = `mailto:?subject=${encodeURIComponent(title)}&body=${encodeURIComponent(`${shareText}\n\n${url}`)}`; };

  const btn = "h-10 w-10 inline-flex items-center justify-center rounded-full border border-[#E5DFD5] text-[#6B655F] hover:text-[#8E9A86] hover:border-[#8E9A86] transition-colors";

  return (
    <div className={`flex items-center gap-2 flex-wrap ${className}`} data-testid="share-row">
      <button onClick={nativeShare} data-testid="share-native" className="inline-flex items-center gap-2 text-sm font-medium text-[#3A3632] rounded-full border border-[#8A8175] px-4 h-10 hover:bg-white transition-colors">
        <Share2 className="h-4 w-4" /> Share
      </button>
      <button onClick={copyLink} aria-label="Copy link" title="Copy link" data-testid="share-copy" className={btn}>
        {copied ? <Check className="h-4 w-4 text-[#8E9A86]" /> : <Link2 className="h-4 w-4" />}
      </button>
      <button onClick={fb} aria-label="Share on Facebook" title="Share on Facebook" data-testid="share-facebook" className={btn}><Facebook className="h-4 w-4" /></button>
      <button onClick={x} aria-label="Share on X" title="Share on X" data-testid="share-x" className={btn}><Twitter className="h-4 w-4" /></button>
      <button onClick={email} aria-label="Share by email" title="Share by email" data-testid="share-email" className={btn}><Mail className="h-4 w-4" /></button>
    </div>
  );
};
